<template>
  <div id="app">
    <!-- <div class="appheader" >
      <div class="left">
        <img class="logo" :src="require('@/assets/images/detail/culturalCollection/boy.png')" alt="" />
        <span>下载文化广东APP，了解更多内容</span>
      </div>
      <div class="right">
        <div class="btn" @click="toDownload">下载APP</div>
      </div>
    </div> -->

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- <router-view></router-view> -->
  </div>
</template>
<!-- 微信 JS-SDK  -->
<!-- <script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.4.0.js"></script> -->
<!-- uni 的 SDK -->
<!-- <script type="text/javascript" src="https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js"></script> -->

<script>
// document.addEventListener('UniAppJSBridgeReady', function () {
//   document.querySelector('.navigateBack_btn').addEventListener('click', function (evt) {
//     console.log('evt==========>', evt)
//     uni.navigateBack() //sdk中默认如果没有参数，则delta为1
//   })
// })
import * as uniWebView from '@/utils/uni_webview'
import { Notify, Toast, Dialog } from 'vant'
export default {
  name: 'App',
  data() {
    return {
      isApp: false,
    }
  },
  created() {
    // //在页面加载时读取sessionStorage里的状态信息,然后删除sessionStorage
    // if (sessionStorage.getItem('store')) {
    //   this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    //   sessionStorage.removeItem('store')
    // }
    // //在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener('beforeunload', () => {
    //   sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    // })
  },
  methods: {
    toDownload() {
      Dialog.confirm({
        title: '请先下载客户端',
        message: '下载APP后查看完整内容',
        confirmButtonText: '立即下载',
        confirmButtonColor: '#a45d56',
        cancelButtonText: '我知道了',
      })
        .then(() => {
          // on confirm
          window.location.href = 'https://www.pgyer.com/ghjCEr'
        })
        .catch(() => {
          // on cancel
        })
    },
  },
}
</script>
<style lang="scss">
// 引入公共样式
@import '@/assets/css/_common.scss';
@import '@/assets/css/_flex.scss';

html {
  font-size: 20px;
}

::-webkit-scrollbar {
  display: none;
}

#app {
  width: 100%;
  height: 100vh;
}
.has_tabBar {
  padding-bottom: 2.5rem;
}
.open_app {
  z-index: 11;
  width: 100%;
  height: 2.85rem;
  line-height: 2.85rem;
  background: #ffffff;
  padding: 0 0.6rem;
  position: fixed;
  left: 0;
  top: 0;
  img {
    width: 2rem;
    height: 2rem;
  }
  .content_app {
    font-size: 0.7rem;
    font-weight: 600;
    color: #212121;
  }
  .open_btn {
    height: 1.6rem;
    line-height: 1.6rem;
    background: #a97048;
    border-radius: 0.8rem;
    padding: 0 0.6rem;
    font-size: 0.7rem;
    font-weight: 400;
    color: #ffffff;
  }
}
.summit_button {
  position: fixed;
  bottom: 0;
  padding-top: 0.6rem;
  padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
  width: 100%;
  height: 3.2rem;
  line-height: 3.2rem;
  background: #fff;
  .btn,
  .disabled {
    width: calc(100% - 1.4rem);
    height: 2rem;
    line-height: 2rem;
    // background: #47988a;
    background: #a97048;
    border-radius: 1.1rem;
    text-align: center;
    font-size: 0.8rem;
    color: #fff;
  }
  .disabled {
    color: #ffffff;
    background: #cccccc;
  }
}
.van-share-sheet__options {
  padding: 16px 8px !important;
}
.van-share-sheet__option {
  flex: 25%;
}

.video-js {
  width: 100% !important;
  height: 100% !important;
  .vjs-big-play-button {
    height: 3.5rem !important;
    width: 3.5rem !important;

    border-radius: 50% !important;
    background-image: url('../src/assets/images/detail/performance/play_icon.png') !important;
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
    border: none !important; // @stylint ignore
    box-shadow: none !important; // @stylint ignore

    &::before {
      content: '';
      // display: none;
    }
    &::hover {
      background-color: transparent;
      opacity: 0.7;
    }
    .vjs-icon-placeholder {
      display: none;
    }
  }
  .vjs-poster {
    background-size: 100% 100% !important;
  }
}
.appheader {
  width: 100%;
  height: 3.35rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0.6rem;
  z-index: 9999;
  font-size: 0.7rem;
  color: #212121;
  .left {
    display: flex;
    align-items: center;
    .logo {
      width: 2rem;
      height: 2rem;
      margin-right: 0.2rem;
    }
  }
  .right {
    width: 4rem;
    height: 1.6rem;
    background: #a97048;
    border-radius: 0.8rem;
    color: #fff;
    text-align: center;
    line-height: 1.6rem;
  }
}
.zhezhao {
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.3);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9998;
}
</style>
